/* page */
/*--------------------------------------------------------------------------------*/
export * from '../index';
const app = document.querySelector<HTMLElement>('#app');
/*--------------------------------------------------------------------------------*/
export type PageParams = {
    size?: string;
    icon?: string;
    title?: string;
    template?: string;
    button?: {
        side?: boolean;
        tab?: boolean;
    };
    sidebar?: string;
    tabbar?: string;
    actbar?: string;
    uri?: string;
};
/*--------------------------------------------------------------------------------*/
export const create = (params: PageParams): boolean => {
    if (!app) return false;
    const size = params.size ?? '';
    const template = params.template ?? '';
    // content
    const content = document.createElement('div');
    content.id = 'app-content';
    content.innerHTML = template;
    app.appendChild(content);
    // page init
    let newNav = false;
    if (size == 'full') {
        navRemove();
        app.classList.add('full-page');
    } else {
        app.classList.remove('full-page');
        if (document.querySelector('#topbar')) {
            setTopbar(params);
        } else {
            navCreate(params);
            setTopbar(params);
            newNav = true;
        }
    }
    return newNav;
};
/*--------------------------------------------------------------------------------*/
// ### navbar ###
/*--------------------------------------------------------------------------------*/
const navCreate = (params: PageParams) => {
    // topbar
    const topbar = document.createElement('nav');
    const tabbar = document.createElement('nav');
    const sidebar = document.createElement('nav');
    topbar.id = 'topbar';
    tabbar.id = 'tabbar';
    sidebar.id = 'sidebar';
    topbar.innerHTML = /*html*/ `
        <div class="container">
            <div class="box left">
                <button id="nav-back" class="topbar-btn icon"
                    onclick="history.back()">&#xf053;</button>
                <button id="nav-side" class="topbar-btn icon">&#xf0c9;</button>
                <div class="title"></div>
            </div>
            <div id="actbar" class="box right"></div>
        </div>
    `;
    tabbar.innerHTML = params.tabbar ?? '';
    sidebar.innerHTML = params.sidebar ?? '';
    document.body.prepend(topbar, tabbar, sidebar);
    // nav-side
    sideBtnEvent(sidebar);
    const navSide = topbar.querySelector<HTMLButtonElement>('#nav-side');
    if (navSide) navSide.onclick = () => {
        const posLeft = sidebar.getBoundingClientRect().left;
        if (posLeft == 0) sideClose(sidebar);
        else sideOpen(sidebar);
    };
    const btnSideClose = sidebar.querySelector<HTMLButtonElement>('#btn-close');
    if (btnSideClose) btnSideClose.onclick = () => sideClose(sidebar);
};
/*--------------------------------------------------------------------------------*/
const navRemove = () => {
    const topbar = document.querySelector<HTMLElement>('#topbar');
    const tabbar = document.querySelector<HTMLElement>('#tabbar');
    const sidebar = document.querySelector<HTMLElement>('#sidebar');
    if (topbar) topbar.remove();
    if (tabbar) tabbar.remove();
    if (sidebar) sidebar.remove();
    if (app) app.className = '';
};
/*--------------------------------------------------------------------------------*/
const setTopbar = (params: PageParams) => {
    const topbar = document.querySelector<HTMLElement>('#topbar');
    if (!topbar) return;
    // title
    const title = params.title ?? 'Page Title';
    topbar.querySelector<HTMLElement>('.title')!.innerText = title;
    // icon
    const navBack = document.querySelector<HTMLElement>('#topbar #nav-back')!;
    navBack.innerHTML = params.icon ?? '&#xf053;';
    // navside
    const navSide = document.querySelector<HTMLElement>('#topbar #nav-side')!;
    if (params.button?.side) {
        navSide.style.display = 'block';
        navBack.style.display = 'none';
    } else {
        navSide.style.display = 'none';
        navBack.style.display = 'block';
    }
    // actbar
    const actbar = topbar.querySelector<HTMLElement>('#actbar');
    if (actbar) actbar.innerHTML = params.actbar ?? '';
    // tabbar
    const tabbar = document.querySelector<HTMLElement>('#tabbar');
    if (!tabbar) return;
    if (params.button?.tab) {
        tabbar.style.display = 'block';
        if (app) app.classList.add('tabbar');
    } else {
        tabbar.style.display = 'none';
        if (app) app.classList.remove('tabbar');
    }
    // tabbar active
    tabActive(params.uri);
};
/*--------------------------------------------------------------------------------*/
const tabActive = (uri: string | undefined) => {
    if (!uri) return;
    if (uri.indexOf('#') > 0) {
        uri = uri.substring(0, uri.indexOf('#'));
    }
    const btn = document.querySelectorAll<HTMLButtonElement>('#tabbar button');
    btn.forEach(el => {
        if (!el.disabled) {
            const path = el.getAttribute('href');
            if (uri == path) {
                el.classList.add('active');
            } else {
                el.classList.remove('active');
            }
        }
    });
};
/*--------------------------------------------------------------------------------*/
const sideBtnEvent = (sidebar: HTMLElement) => {
    const btn = sidebar.querySelectorAll('a');
    btn.forEach(el => {
        el.addEventListener('click', () => {
            sideClose(sidebar);
        });
    });
};
const sideOpen = (sidebar: HTMLElement) => {
    sidebar.classList.remove('close');
    sidebar.classList.add('open');
    // overlay
    const overlay = document.createElement('div');
    overlay.id = 'side-overlay';
    overlay.className = 'overlay';
    overlay.style.animation = 'fade-in 0.4s forwards';
    document.body.appendChild(overlay);
    overlay.onclick = () => sideClose(sidebar);
};
const sideClose = (sidebar: HTMLElement) => {
    sidebar.classList.remove('open');
    sidebar.classList.add('close');
    // overlay
    const overlay = document.querySelector<HTMLElement>('#side-overlay');
    if (overlay) {
        overlay.style.animation = 'fade-out 0.4s forwards';
        overlay.onanimationend = () => overlay.remove();
    }
};
/*--------------------------------------------------------------------------------*/
